import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/search.svg'
import _imports_1 from '@/assets/icons/pagefirstenabled.svg'
import _imports_2 from '@/assets/icons/pagefirstdisabled.svg'
import _imports_3 from '@/assets/icons/pagelastenabled.svg'
import _imports_4 from '@/assets/icons/pagelastdisabled.svg'
import _imports_5 from '@/assets/icons/warnerror.svg'


const _hoisted_1 = {
  key: 0,
  class: "innerModal"
}
const _hoisted_2 = {
  key: 0,
  class: "bottommargin titlestyle"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"25px"},
  alt: "searchimg",
  title: "searchimg"
}, null, -1)
const _hoisted_4 = { "data-cy": "users-table" }
const _hoisted_5 = { class: "pagelabel" }
const _hoisted_6 = {
  key: 0,
  src: _imports_1,
  style: {"width":"20px"},
  alt: "firstpageiconimg",
  title: "firstpageiconimg"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_2,
  style: {"width":"20px"},
  alt: "firstpageiconimg",
  title: "firstpageiconimg"
}
const _hoisted_8 = {
  key: 0,
  src: _imports_3,
  style: {"width":"20px"},
  alt: "lastpageiconimg",
  title: "lastpageiconimg"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_4,
  style: {"width":"20px"},
  alt: "lastpageiconimg",
  title: "lastpageiconimg"
}
const _hoisted_10 = {
  key: 2,
  class: "maxitemsdiv"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "warnimagestyle",
  alt: "warnimg",
  title: "warnimg"
}, null, -1)
const _hoisted_12 = {
  class: "errordiv",
  style: {"padding":"1rem 0"}
}
const _hoisted_13 = { class: "buttonsdiv btnbottomdiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_ctx.taskType === 'assignaddonexclusiveusers')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.taskType === 'assignaddonexclusiveusers')
          ? (_openBlock(), _createElementBlock("label", _hoisted_2, "Select available users"))
          : _createCommentVNode("", true),
        _createVNode(_component_el_input, {
          id: "assignusersearch",
          modelValue: _ctx.userSearchValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userSearchValue) = $event)),
          placeholder: "Search",
          type: "search",
          debounce: "1000",
          class: "rightmargin inpstyle bottommargin",
          "data-cy": "users-search"
        }, {
          suffix: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", {
          class: _normalizeClass(
        !_ctx.showError
          ? 'useroverflowdiv heightnoerror'
          : 'heightwitherror useroverflowdiv'
      )
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.taskType === 'assignaddonexclusiveusers')
              ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  id: "assignusertable",
                  ref: "assignusertable",
                  data: _ctx.availableUsers,
                  style: {"width":"100%"},
                  "header-cell-style": _ctx.headerstyle,
                  "row-style": _ctx.rowdatastyle,
                  onSelect: _ctx.handleSelectionChange,
                  onSelectAll: _ctx.handleSelectionChange,
                  onSortChange: _ctx.handleSorting,
                  "default-sort": { prop: 'userName', order: 'ascending' },
                  "empty-text": "No users available"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      type: "selection",
                      width: "55"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "User Name",
                      prop: "userName",
                      sortable: ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Email",
                      prop: "email"
                    })
                  ]),
                  _: 1
                }, 8, ["data", "header-cell-style", "row-style", "onSelect", "onSelectAll", "onSortChange"])), [
                  [_directive_loading, _ctx.loading]
                ])
              : _createCommentVNode("", true)
          ])
        ], 2),
        (_ctx.paging.totalPages > 1 && _ctx.taskType === 'assignaddonexclusiveusers')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(!_ctx.showError ? 'usermodalpagingdiv' : 'usermodalpagingdivwitherror')
            }, [
              _createElementVNode("label", _hoisted_5, [
                _createElementVNode("strong", null, "Page " + _toDisplayString(_ctx.paging.currentPage) + " / " + _toDisplayString(_ctx.paging.totalPages), 1)
              ]),
              _createVNode(_component_el_button, {
                plain: "",
                class: "paginationbtn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paging.currentPage = 1)),
                id: "firstpage",
                disabled: _ctx.paging.currentPage === 1
              }, {
                default: _withCtx(() => [
                  (_ctx.paging.currentPage !== 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : _createCommentVNode("", true),
                  (_ctx.paging.currentPage === 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_pagination, {
                layout: "prev, next",
                total: _ctx.paging.totalRowsCount,
                "page-size": _ctx.paging.perPage,
                "current-page": _ctx.paging.currentPage,
                "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paging.currentPage) = $event))
              }, null, 8, ["total", "page-size", "current-page"]),
              _createVNode(_component_el_button, {
                plain: "",
                class: "paginationbtn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.paging.currentPage = _ctx.paging.totalPages)),
                id: "lastpage",
                disabled: _ctx.paging.currentPage === _ctx.paging.totalPages
              }, {
                default: _withCtx(() => [
                  (_ctx.paging.currentPage !== _ctx.paging.totalPages)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                    : _createCommentVNode("", true),
                  (_ctx.paging.currentPage === _ctx.paging.totalPages)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disabled"])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.showError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.errormsg) + " " + _toDisplayString(_ctx.maxSeatsReachedAddOns.map((a) => a.productName).join(", ")), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.taskType === 'assignaddonexclusiveusers')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                id: "assignusernext",
                round: "",
                class: "btnstyle ml-4",
                variant: "warning",
                onClick: _ctx.nextClickHandler,
                disabled: !_ctx.enableNextButton,
                "data-cy": "addons-button-next"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Next ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          (_ctx.taskType === 'assignaddonexclusiveusers')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                round: "",
                class: "btnstyle ml-4",
                variant: "warning",
                id: "backbutton",
                onClick: _ctx.backClickHandler,
                "data-cy": "addons-button-back"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Back ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            id: "assignusercancel",
            round: "",
            variant: "outline-dark",
            onClick: _ctx.cancelInvite,
            class: "cancelbtn",
            "data-cy": "addons-button-cancel"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]))
    : _createCommentVNode("", true)
}